import React from "react";
import { useLocation } from "react-router-dom";
import useAssinatura from "../hooks/useAssinatura";
import LoadingComLayout from "./LoadingComLayout";
import PaywallPlanosModal from "./PaywallPlanosModal";

export default function RequireActivePlan({ children, barbeariaId }) {
  const location = useLocation();

  // 1. Hook sempre no topo
  const { loading, isBlocked, daysLeft } = useAssinatura({ barbeariaId });

  // 2. White-list (REMOVI A BARRA '/' DAQUI para tratar com segurança abaixo)
  const rotasLiberadas = [
    "/cadastro-barbearia",
    "/cadastro-servico",
    "/cadastro-barbeiro",
    "/planos",
    "/assinatura",
    "/assinatura/sucesso",
    "/ajuda",
    "/login"
  ];

  const isWhitelisted = rotasLiberadas.includes(location.pathname);

  // SE FOR ROTA LIBERADA: Retorna logo
  if (isWhitelisted) {
    return <>{children}</>;
  }

  // 3. Lógica Especial para a Home ("/"):
  // Se estivermos na Home e AINDA não tivermos o ID da barbearia (carregando contexto),
  // precisamos renderizar o children (Home) para que ele possa buscar os dados do usuário e decidir se é proprietário.
  // Se barrarmos aqui por falta de ID, a Home nunca roda e entra em loop infinito.
  // Mas assim que o ID chegar, essa condição falha e ele cai na verificação de bloqueio abaixo.
  if (location.pathname === "/" && !barbeariaId) {
    return <>{children}</>;
  }

  // 4. Lógica de Loading padrão (aguarda ID ou verificação da assinatura)
  if (!barbeariaId || loading) {
    return <LoadingComLayout />;
  }

  // 5. Bloqueio de Assinatura
  const showBlockModal = isBlocked && daysLeft !== undefined && daysLeft !== null;

  if (showBlockModal) {
    return (
        <>
             <div style={{ filter: "blur(5px)", pointerEvents: "none" }}>
                {children}
             </div>
            <PaywallPlanosModal daysLeft={daysLeft} />
        </>
    );
  }

  return <>{children}</>;
}